import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { LanguageProvider } from './contexts/LanguageContext';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import ProtectedRoute from './components/ProtectedRoute';
import Home from './pages/Home';
import About from './pages/About';
import AfricaSurfTour from './pages/AfricaSurfTour';
import Federations from './pages/Federations';
import Talents from './pages/Talents';
import News from './pages/News';
import NewsArticle from './pages/NewsArticle';
import Gallery from './pages/Gallery';
import Live from './pages/Live';
import Partners from './pages/Partners';
import Contact from './pages/Contact';
import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminNews from './pages/admin/AdminNews';
import AdminAthletes from './pages/admin/AdminAthletes';
import AdminFederations from './pages/admin/AdminFederations';
import AdminPartners from './pages/admin/AdminPartners';
import AdminGallery from './pages/admin/AdminGallery';
import AdminSliders from './pages/admin/AdminSliders';
import AdminMessages from './pages/admin/AdminMessages';
import AdminSettings from './pages/admin/AdminSettings';
import AdminTour from './pages/admin/AdminTour';

// Component to scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <LanguageProvider>
      <Router>
        <ScrollToTop />
        <div className="min-h-screen bg-gray-50">
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={
              <>
                <Navigation />
                <Home />
                <Footer />
              </>
            } />
            <Route path="/about" element={
              <>
                <Navigation />
                <About />
                <Footer />
              </>
            } />
            <Route path="/africa-surf-tour" element={
              <>
                <Navigation />
                <AfricaSurfTour />
                <Footer />
              </>
            } />
            <Route path="/federations" element={
              <>
                <Navigation />
                <Federations />
                <Footer />
              </>
            } />
             <Route path="/live" element={
              <>
                <Navigation />
                <Live />
                <Footer />
              </>
            } />
            <Route path="/talents" element={
              <>
                <Navigation />
                <Talents />
                <Footer />
              </>
            } />
            <Route path="/news" element={
              <>
                <Navigation />
                <News />
                <Footer />
              </>
            } />
            <Route path="/news/:id" element={
              <>
                <Navigation />
                <NewsArticle />
                <Footer />
              </>
            } />
            <Route path="/gallery" element={
              <>
                <Navigation />
                <Gallery />
                <Footer />
              </>
            } />
            <Route path="/partners" element={
              <>
                <Navigation />
                <Partners />
                <Footer />
              </>
            } />
            <Route path="/contact" element={
              <>
                <Navigation />
                <Contact />
                <Footer />
              </>
            } />
            
            {/* Admin Routes */}
            <Route path="/admin3256" element={<AdminLogin />} />
            <Route path="/admin3256/dashboard" element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            } />
            <Route path="/admin3256/news" element={
              <ProtectedRoute>
                <AdminNews />
              </ProtectedRoute>
            } />
            <Route path="/admin3256/athletes" element={
              <ProtectedRoute>
                <AdminAthletes />
              </ProtectedRoute>
            } />
            <Route path="/admin3256/federations" element={
              <ProtectedRoute>
                <AdminFederations />
              </ProtectedRoute>
            } />
            <Route path="/admin3256/partners" element={
              <ProtectedRoute>
                <AdminPartners />
              </ProtectedRoute>
            } />
            <Route path="/admin3256/gallery" element={
              <ProtectedRoute>
                <AdminGallery />
              </ProtectedRoute>
            } />
            <Route path="/admin3256/sliders" element={
              <ProtectedRoute>
                <AdminSliders />
              </ProtectedRoute>
            } />
            <Route path="/admin3256/messages" element={
              <ProtectedRoute>
                <AdminMessages />
              </ProtectedRoute>
            } />
            <Route path="/admin3256/tour" element={
              <ProtectedRoute>
                <AdminTour />
              </ProtectedRoute>
            } />
            <Route path="/admin3256/settings" element={
              <ProtectedRoute>
                <AdminSettings />
              </ProtectedRoute>
            } />
          </Routes>
        </div>
      </Router>
    </LanguageProvider>
  );
}

export default App;